import { RegardMark } from '@rgrd/component-library'
import { Link, useParams } from 'react-router'

import { ActiveAppNav } from './ActiveAppNav'
import styles from './AppHeader.module.css'
import { CustomerCluster } from './CustomerCluster'
import { ProductSwitcher } from './ProductSwitcher'

/**
 * The suite's application header.
 */
export const AppHeader = () => {
  const { customer } = useParams<{ customer: string }>()

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <Link to={customer ? `/c/${customer}/` : '/'} className={styles.logo}>
          <RegardMark size={26} />
        </Link>
        <ProductSwitcher />
        <ActiveAppNav />
      </div>
      <CustomerCluster />
    </header>
  )
}
